import type {
  redemptionDetailResource,
  redemptionResource,
} from '@porotutu/api/features/crm/redemptions/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { REDEMPTIONS } from '@/api/keys'
import type { CrmRedemptionSort, RedemptionResult, RedemptionStatus } from '../vocabulary'

export type Redemption = ReturnType<typeof redemptionResource>

export type RedemptionDetail = ReturnType<typeof redemptionDetailResource>

export type RedemptionPage = { data: Redemption[]; meta: ListMeta }

export type RedemptionListQuery = ListQuery<CrmRedemptionSort, never> & {
  customer_id?: string
  voucher_id?: string
  result?: RedemptionResult
  status?: RedemptionStatus
}

export const redemptionsQuery = (query: RedemptionListQuery) =>
  queryOptions({
    queryKey: [...REDEMPTIONS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.redemptions.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const redemptionQuery = (id: string) =>
  queryOptions({
    queryKey: [...REDEMPTIONS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.redemptions({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<RedemptionListQuery>('/api/v1/crm/redemptions/export', {
  always: ['customer_id', 'voucher_id'],
  viewed: ['result', 'status', 'search'],
})
